import { Link } from "react-router";
import logoSBAWhite from "@assets/events-awards/logo-sba-white.svg";
import FooterMenuLinks from "@events-awards/components/EventsAwardsFooterComponents/FooterMenuLinks";
import { EVENTS_AWARDS_SBA_PATH } from "@events-awards/utils/constants";
import { SBA_FOOTER_MENU } from "@sba/utils/constants";

/**
 * Component to display footer for desktop view in SBA pages
 */
const SBAFooterDesktop = (): React.ReactElement => {
  return (
    <div
      className="grid w-full grid-cols-12 text-center"
      data-testid="sba-footer-desktop-component"
    >
      <div className="col-span-2 pl-0 pr-3">
        <Link to={EVENTS_AWARDS_SBA_PATH} reloadDocument>
          <img
            src={logoSBAWhite}
            alt="Singapore Business Awards logo"
            width={176}
            height={23.55}
          />
        </Link>
      </div>

      <div className="col-span-4 pl-1 pr-3">
        <h3 className="mb-2 text-left font-public-sans text-base font-medium">
          About Us
        </h3>

        <p className="text-left leading-normal text-white">
          The Singapore Business Awards (SBA), launched in 1985, is jointly
          organised by The Business Times, and DHL. The objectives of the awards
          are to acknowledge the vital contributions made by companies and
          business leaders to Singapore&apos;s development and to encourage the
          entrepreneurial spirit in Singapore. The awards also give recognition
          to excellence in corporate management.
        </p>
      </div>

      <div className="col-span-3 px-3">
        <p className="mb-4 text-left font-semibold">Sections</p>

        <div className="my-2 flex flex-row">
          <FooterMenuLinks
            items={SBA_FOOTER_MENU.slice(0, 3)}
            className="space-y-4"
          />

          <FooterMenuLinks
            items={SBA_FOOTER_MENU.slice(3, 6)}
            className="space-y-4 pl-20"
          />
        </div>
      </div>

      <div className="col-span-2 pl-5 pr-3">
        <p className="mb-4 text-left font-semibold">Quick Links</p>

        <FooterMenuLinks
          items={SBA_FOOTER_MENU.slice(6, 7)}
          className="space-y-2"
        />
      </div>
    </div>
  );
};

export default SBAFooterDesktop;
